export default __webpack_public_path__ + "static/media/Empresa4.68796183.png";